import React, { useState } from "react";
import { Link } from "react-router-dom";
import { formatCurrency, getLink, toast } from "../../utils/helpers";
import dayjs from "dayjs";
import { postRequest } from "../../utils/request";

const valueRender = (value, frecuencia) => {
    if (frecuencia === "semanal") {
        const dias = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
        
        return dias[value.weekday - 1];
    }

    if (frecuencia === "anual") {
        const meses = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
        return meses[value.month - 1];
    }

    return value.day_of_month;
};

const CompraRow = ({ recurrente, toggleDeleteModal, setRecurrente }) => {
    const [showCompras, setShowCompras] = useState(false);
    const [generandoCompra, setGenerandoCompra] = useState(false);

	const toggleFacturas = () => {
		setShowCompras((state) => !state);
	};

    const generarProximaCompra = async (id) => {
        if (generandoCompra) return;

        setGenerandoCompra(true);

        try {
            const res = await postRequest(`compras-recurrentes/${id}/proxima-ocurrencia`);

            if (res.message) toast(res.message, "error");
            else{
                toast("Próxima compra generada exitosamente", "success");
                setRecurrente({
                    ...recurrente,
                    compras: [...recurrente.compras, res.data],
                })
            }
        } catch (error) {
            console.error("Error al generar la próxima compra:", error);
        } finally {
            setGenerandoCompra(false);
        }
    };

    return <div className={`descuento-item di-${recurrente.id}`}>
        <div className="descuento-row descuento-info" onClick={() => toggleFacturas()}>
            <div>
                <Link to={getLink(`/contactos?id=${recurrente.compra.contacto_id}`)}>
                    {recurrente.compras[0].contacto}
                </Link>
            </div>
            <div>
                <small><strong>Estado:</strong> {recurrente.estado}</small>
                <small><strong>Frecuencia:</strong> {recurrente.frecuencia} </small>
                <small><strong>Cada:</strong> {recurrente.cada}</small>
                <small>
                    <strong>
                        {recurrente.frecuencia === "anual" ? "Los Meses" : "Los Días"}:
                    </strong>

                    {recurrente.values.map((value) => valueRender( value, recurrente.frecuencia)).join(", ")}
                </small>
                {recurrente.frecuencia === "anual" && (
                    <small><strong>El Día:</strong> {recurrente.values[0].day_of_month}</small>
                )}
            </div>
            <div>
                <div>{ formatCurrency(recurrente.compra.total) }</div>
                # Ocurrencias: {recurrente.ocurrencias > 0 ? recurrente.ocurrencias : "∞"}
            </div>
            <div><strong>{dayjs(recurrente.fecha_inicio).format("DD/MM/YYYY")}</strong></div>
            <div>
                <small><strong>Próximo:</strong> {recurrente.proximo ? dayjs(recurrente.proximo).format("DD/MM/YYYY") : "N/A"}</small>
                <small><strong>Final:</strong> {recurrente.ocurrencias > 0 ? dayjs(recurrente.compras[recurrente.ocurrencias - 1].fecha).format("DD/MM/YYYY") : "∞"}</small>
            </div>
            <div>
                <div className="table-data-feature">
                    <div className="dropdown">
                        <button className="au-btn au-btn-icon au-btn-filter">Acciones</button>
                        <div className="dropdown-menu" style={{ left: "auto", right: 0 }}>
                            {recurrente.ocurrencias < 0 || recurrente.compras.length < recurrente.ocurrencias ? (
                                <button
                                    onClick={ (e) => generarProximaCompra(recurrente.id)}
                                    type="button"
                                    className="dropdown-item"
                                    title="Generar próxima ocurrencia"
                                    disabled={generandoCompra}
                                >
                                    {generandoCompra ? "Generando..." : "Generar Próxima Ocurrencia"}
                                </button>
                            ) : ""}
                            <Link
                                to={getLink(
                                    `/compras-recurrentes/${recurrente.id}/editar`
                                )}
                                target="_blank"
                                className="dropdown-item"
                                title="Editar"
                            >
                                Editar
                            </Link>
                            <button
                                className="dropdown-item"
                                onClick={() =>
                                    toggleDeleteModal(recurrente)
                                }
                            >
                                Eliminar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {recurrente.compras?.length > 0 && (
            <div className={`descuento-cuotas ${showCompras ? "show" : ""}`}>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Numeración</th>
                            <th>Monto</th>
                            <th>Fecha</th>
                            <th>Estado</th>
                        </tr>
                    </thead>

                    <tbody>
                        {recurrente.compras.map(
                            (compra, index) => (
                                <tr
                                    key={compra.id}
                                    className={`cuota ${compra.estado}`}
                                >
                                    <td>{compra.ncf}</td>
                                    <td>{formatCurrency(compra.total)}</td>
                                    <td>
                                        <div>
                                            <strong>Emisión: </strong>
                                            {dayjs(
                                                compra.fecha_emision ?? compra.fecha
                                            ).format("DD/MM/YYYY")}
                                        </div>
                                        <div>
                                            {compra.estado ===
                                                "pagada" && (
                                                <>
                                                    <strong>
                                                        Pagada:{" "}
                                                    </strong>
                                                    {dayjs(
                                                        compra.fecha_pago
                                                    ).format("DD/MM/YYYY")}
                                                </>
                                            )}
                                        </div>
                                    </td>
                                    <td className="cuota__estado">
                                        {compra.estado}
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>
        )}
    </div>;
};

export default CompraRow;